/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ position: NonNullable<unknown>, total: NonNullable<unknown> }} Settings_Template_Topic_Drag_EndInputs */



/**
* | output |
* | --- |
* | "Topic dropped in position {position} of {total}." |
*
* @param {Settings_Template_Topic_Drag_EndInputs} inputs
* @param {{ locale?: "en" | "nl" | "fr" }} options
* @returns {LocalizedString}
*/
export const settings_template_topic_drag_end = /** @type {((inputs: Settings_Template_Topic_Drag_EndInputs, options?: { locale?: "en" | "nl" | "fr" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Settings_Template_Topic_Drag_EndInputs, { locale?: "en" | "nl" | "fr" }, {}>} */ ((i, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "nl") return /** @type {LocalizedString} */ (`Onderwerp neergezet op plaats ${i?.position} van ${i?.total}.`)
	if (locale === "fr") return /** @type {LocalizedString} */ (`Sujet déposé en position ${i?.position} sur ${i?.total}.`)
	return /** @type {LocalizedString} */ (`Topic dropped in position ${i?.position} of ${i?.total}.`)
});